module.exports = __webpack_public_path__ + "static/about-351c1221a03e374c4ff5f9af57b6d1fd.jpg";